import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=5f87e5a3&scoped=true&"
import script from "./OptionList.vue?vue&type=script&lang=js&"
export * from "./OptionList.vue?vue&type=script&lang=js&"
import style0 from "./OptionList.vue?vue&type=style&index=0&id=5f87e5a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f87e5a3",
  null
  
)

export default component.exports